import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { ArrowUploadRegular } from "@fluentui/react-icons";
import { Button } from "./button";
/**
 * A button that triggers a file upload dialog.
 * Combines a Button with a hidden file input.
 * @param props UploadButtonProps
 * @returns UploadButton component
 */
export const UploadButton = (props) => {
    const { onUpload, accept, label, ...buttonProps } = props;
    UploadButton.displayName = "UploadButton";
    const inputRef = useRef(null);
    const handleClick = () => {
        inputRef.current?.click();
    };
    const handleChange = (evt) => {
        const files = evt.target.files;
        if (files && files.length) {
            onUpload(files);
        }
        evt.target.value = "";
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { icon: ArrowUploadRegular, title: label ?? "Upload", label: label, onClick: handleClick, ...buttonProps }), _jsx("input", { ref: inputRef, type: "file", accept: accept, style: { display: "none" }, onChange: handleChange })] }));
};
//# sourceMappingURL=uploadButton.js.map